import axios from "axios";

const API = axios.create({
  baseURL: "https://grs.jeccac.in/api",
});

export const submitGrievance = (data) => API.post("/grievance/submit", data);
